(() => {
  const section = document.querySelector('.wcs-model-inquiry');
  if (!section) return;
  const params = new URLSearchParams(window.location.search);
  const model = (params.get('model') || '').trim().slice(0, 200);
  if (!model) return;
  // Optional matching details belong on this request page, not product pages.
  const controllerHelp = section.querySelector('[data-wcs-controller-photo-help]');
  if (controllerHelp) {
    const isFanLimitController = /\bl4064[a-z0-9/-]*\b|fan\s*(?:and|&)\s*limit|ventilateur.*(?:limiteur|limite)/i.test(model);
    controllerHelp.hidden = !isFanLimitController;
  }
  const search = section.querySelector('input[type="search"]');
  const searchSku = (params.get('search') || '').trim();
  // Older product-body links include a SKU in the inquiry context but omit search.
  // Search that exact identifier while retaining the full context for the inquiry.
  const embeddedSku = model.match(/(?:^|\/\s*)SKU:\s*(WCS-[a-z0-9][a-z0-9._-]{0,75})\s*$/i);
  const searchTerm = /^[a-z0-9][a-z0-9._-]{0,79}$/i.test(searchSku)
    ? searchSku : (embeddedSku ? embeddedSku[1] : model);
  if (search && !search.value) search.value = searchTerm;

  let contextUrl = '';
  try {
    const raw = params.get('product_url');
    const parsed = raw ? new URL(raw, window.location.origin) : null;
    // Accept canonical English paths and this page's Shopify locale prefix only.
    const root = (section.dataset.rootUrl || '/').replace(/\/$/, '');
    const path = parsed?.pathname || '';
    const catalogPath = root && path.startsWith(`${root}/`) ? path.slice(root.length) : path;
    if (parsed && parsed.origin === window.location.origin && /^\/(products|collections)\/[a-z0-9-]+\/?$/i.test(catalogPath)) {
      contextUrl = `${parsed.origin}${parsed.pathname}`;
      // A collection identifies the browsing context, not a selected product.
      // Preserve variant IDs only on products; discard other query parameters.
      const variant = parsed.searchParams.get('variant');
      if (catalogPath.startsWith('/products/') && variant && /^[1-9]\d{0,19}$/.test(variant)) {
        contextUrl += `?variant=${variant}`;
      }
    }
  } catch { /* Ignore invalid or external catalog references. */ }
  const context = contextUrl ? `${model}\n${contextUrl}\n` : `${model}\n`;

  // Forms loads asynchronously in its own shadow root; never replace customer input.
  const fillContext = () => {
    const embed = document.querySelector('shopify-forms-embed#app-embed');
    const field = embed?.shadowRoot?.querySelector('textarea[name="custom#model_or_question"]');
    if (!field) return false;
    if (field.value) return true;
    // Other fields may be active while Forms loads; defer only for this question field.
    if (embed.shadowRoot.activeElement === field) return false;
    if (!field.value) {
      const setter = Object.getOwnPropertyDescriptor(HTMLTextAreaElement.prototype, 'value').set;
      setter.call(field, context);
      field.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
      field.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
    }
    return true;
  };
  if (fillContext()) return;
  let attempts = 0;
  const timer = window.setInterval(() => {
    if (fillContext() || ++attempts >= 60) window.clearInterval(timer);
  }, 250);
  window.addEventListener('pagehide', () => window.clearInterval(timer), { once: true });
})();
